import { yupResolver } from "@hookform/resolvers/yup";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { Grid, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { IdentificacionTextField } from "@/erp/compras/proveedores/shared/components/IdentificacionProveedorTextField";
import { AcutocompletePromocion } from "@/erp/sytem-sttings/promociones/shared/components";
import {
  RELATED_PERMISSIONS_SAVEFORM,
  ROUTER_PATHS,
  TIPO_EMPLEADO_CHOICE,
  TIPO_IDENTIFICACIONES_CHOICE,
  USER_ROLES_CHOICE,
  a11yProps,
  gridSize,
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg6,
  useCheckPermissionsArray,
  useLoaders,
  useTabsFormOnly,
  usuarioSistemaFormSchema,
} from "@/shared";
import {
  useFetchAllCountries,
  useFetchAreas,
  useFetchCanalVentaAll,
  useFetchCitiesEnabled,
  useFetchDepartamentos,
  useFetchGrupoSistemas,
  useFetchProvinces,
  useFetchSearchIdentification,
  useFetchSectors,
  useFetchZones,
  usefetchEmpresas,
} from "@/shared/actions/erp";
import {
  CreateUpdUserSistemaData,
  useCreateUsuarioSistema,
  useUpdateUsuarioSistema,
} from "@/shared/actions/erp/administration/usuarios";
import { useFetchCargos } from "@/shared/actions/erp/empleados";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomCircularPorgress,
  CustomPasswordTextField,
  CustomTabPanel,
  CustomTextField,
  FormTabsOnly,
  SampleCheckbox,
  SingleIconButton,
  TabTextLabel,
  TabsFormBoxScene
} from "@/shared/components/ui";
import CustomCellphoneTextField from "@/shared/components/ui/CustomCellphoneTextField";
import TimeClockComponente from "@/shared/components/ui/TimeClock/TimeClockComponente";
import {
  AlertSeverityEnum,
  Area,
  CanalVenta,
  Departamento,
  Empresa,
  GrupoSistema,
  IDataRuc,
  TipoDocumentoNameEnum,
  UsuarioSistemaPOST,
  UsuariosSistemaGET,
} from "@/shared/interfaces";
import { City, Country, Province, Sector, Zone } from "@/shared/interfaces/erp";
import { Cargos } from "@/shared/interfaces/erp/empleados";
import {
  DAYS_WEEK_COLLECTION,
  WorkDaysCollection,
  diasPermitidosInterface,
} from "@/shared/interfaces/erp/global/days.interface";
import { BODEGAS, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import {
  getDiasPermitidos,
  getTimesForClockInWorkSchedules,
  hoursBetweenRange,
} from "@/shared/utils/horarios-acceso-usuarios";
import { useUiStore } from "@/store/ui";
import { AVAILABLE_ROLES_ACTIONS } from "../../constants";
import AgregarBodegaUsuario from "../BodegaUbicacion/AgregarBodegaUsuario";
import AgregarUbicacionUsuario from "../UbicacionUsuario/AgregarUbicacionUsuario";

export interface SaveUsuarioSistemaProps {
  title: string;
  systemUsuer?: UsuariosSistemaGET;
}

type SaveUsuarioSistemaForm = Pick<
  UsuarioSistemaPOST,
  | "tipo_identificacion"
  | "identificacion"
  | "razon_social"
  | "username"
  | "password"
  | "email"
  | "empresa"
  | "area"
  | "departamento"
  | "rol"
  | "is_active"
> & {
  permisos?: number[];
  grupos?: number[];
  isEdit?: boolean;
  canales_venta_adicionales?: string[];
  canal_venta?: string;
  bodegas?: string[];
  ubicaciones?: string[];
  bodegas_destino?: string[];
  ubicaciones_destino?: string[];

  //
  is_active?: boolean;
  // employee ----------------
  create_employee?: boolean;

  direccion?: string;
  telefono_1?: string;
  telefono_2?: string;
  telefono_3?: string;

  // fk
  pais?: string;
  provincia?: string;
  ciudad?: string;
  zona?: string;
  sector?: string;
  cargo?: string;
  tipo_empleado?: string;

  // to handle users schedule
  workDays?: number[];
  hora_inicio_jornada?: Date;
  hora_fin_jornada?: Date;
  dias_permitidos?: diasPermitidosInterface[] | [] | null;

  //to handle request quantity
  cantidad_consultas?: number | null;
};

const SaveUsuarioSistema: React.FC<SaveUsuarioSistemaProps> = ({
  title,
  systemUsuer,
}) => {
  const [dataBodegas, setDataBodegas] = useState<BODEGAS[]>([]);
  const [dataUbicacion, setDataUbicacion] = useState<Ubicaciones[]>([]);

  const [dataBodegasDestino, setDataBodegasDestino] = useState<BODEGAS[]>([]);
  const [dataUbicacionDestino, setDataUbicacionDestino] = useState<
    Ubicaciones[]
  >([]);

  useCheckPermissionsArray([...RELATED_PERMISSIONS_SAVEFORM]);
  const returnUrlUsuariosSistemaPage = ROUTER_PATHS.administration.usuariosNav;
  ///* hooks -----------------
  const navigate = useNavigate();
  const { handleMethodChange, valueTab } = useTabsFormOnly();

  ///* local state -----------------
  const [canWritePassword, setCanWritePassword] = useState<boolean>(true);
  const [canSelectCanalVenta, setCanSelectCanalVenta] =
    useState<boolean>(false);

  ///* global state -----------------
  const setAlert = useUiStore.getState().setAlert;

  ///* form -------------------------
  const form = useForm<SaveUsuarioSistemaForm>({
    resolver: yupResolver(usuarioSistemaFormSchema) as any,
    defaultValues: {
      create_employee: false,
      isEdit: false,
    },
  });
  const {
    formState: { errors },
  } = form;
  const watchedTipoIdentificacion = form.watch("tipo_identificacion");
  const watchedEmpresa = form.watch("empresa");
  const watchedArea = form.watch("area");
  const watchedCreateEmployee = form.watch("create_employee");

  ///* fetch data -------------------
  const {
    data: empresaPagingRes,
    isLoading: isLoadingEmpresas,
    isRefetching: isRefetchingEmpresas,
  } = usefetchEmpresas({
    page_size: 100,
  });
  const {
    data: areaPagingRes,
    isLoading: isLoadingAreas,
    isRefetching: isRefetchingAreas,
  } = useFetchAreas(
    {
      page_size: 300,
      empresa: watchedEmpresa,
    },
    !!watchedEmpresa,
  );
  const {
    data: departamentoPagingRes,
    isLoading: isLoadingDepartamentos,
    isRefetching: isRefetchingDepartamentos,
  } = useFetchDepartamentos(
    {
      page_size: 300,
      empresa: watchedEmpresa,
      area: watchedArea,
    },
    !!watchedArea && !!watchedEmpresa,
  );
  const {
    data: gruposSistemaPagingRes,
    isLoading: isLoadingGruposSistema,
    isRefetching: isRefetchingGruposSistema,
  } = useFetchGrupoSistemas({
    enabled: true,
    params: {
      page_size: 500,
    },
  });
  const {
    data: cargosPagingRes,
    isLoading: isLoadingCargos,
    isRefetching: isRefetchingCargos,
  } = useFetchCargos(
    {
      page_size: 500,
      empresa: watchedEmpresa,
    },
    !!watchedEmpresa && !!watchedCreateEmployee,
  );
  const {
    data: canalesVentaPagingRes,
    isLoading: isLoadingCanalesVenta,
    isRefetching: isRefetchingCanalesVenta,
  } = useFetchCanalVentaAll({
    enabled: true,
    params: {
      page_size: 500,
    },
  });

  const watchedCountry = form.watch("pais");
  const watchedProvince = form.watch("provincia");
  const watchedCity = form.watch("ciudad");
  const watchedZone = form.watch("zona");

  const {
    data: countriesPaging,
    isLoading: isLoadingCountries,
    isRefetching: isRefetchingCountries,
  } = useFetchAllCountries({
    page_size: 600,
  });
  const {
    data: provincesPaging,
    isLoading: isLoadingProvinces,
    isRefetching: isRefetchingProvinces,
  } = useFetchProvinces(
    {
      page_size: 600,
      pais: watchedCountry,
    },
    !!watchedCountry && !!watchedCreateEmployee,
  );
  const {
    data: citiesPaging,
    isLoading: isLoadingCities,
    isRefetching: isRefetchingCities,
  } = useFetchCitiesEnabled({
    params: {
      page_size: 600,
      provincia: watchedProvince,
      pais: watchedCountry,
    },
    enabled: !!watchedProvince && !!watchedCountry && !!watchedCreateEmployee,
  });
  const {
    data: zonesPaging,
    isLoading: isLoadingZones,
    isRefetching: isRefetchingZones,
  } = useFetchZones(
    {
      page_size: 600,
      ciudad: watchedCity,
    },
    !!watchedCity && !!watchedCreateEmployee,
  );
  const {
    data: sectorsPaging,
    isLoading: isLoadingSectors,
    isRefetching: isRefetchingSectors,
  } = useFetchSectors(
    {
      page_size: 600,
      zona: watchedZone,
    },
    !!watchedZone && !!watchedCreateEmployee,
  );

  ///* mutations ---------------------
  const consultaIdentificacion = useFetchSearchIdentification({
    customSuccessMessage: "Datos de identificación encontrados.",
  });
  const createUser = useCreateUsuarioSistema<CreateUpdUserSistemaData>({
    enableErrorRedirect: false,
    navigate,
    returnUrl: returnUrlUsuariosSistemaPage,
    customSuccessMessage: "Usuario creado correctamente",
  });
  const updateUser = useUpdateUsuarioSistema<UsuariosSistemaGET>({
    enableErrorRedirect: false,
    navigate,
    returnUrl: returnUrlUsuariosSistemaPage,
    customSuccessMessage: "Usuario actualizado correctamente",
  });
  ///* handlers ---------------------
  const onSave = async (data: SaveUsuarioSistemaForm) => {
    const startHour = form.getValues().hora_inicio_jornada?.getHours()!;
    const endHour = form.getValues().hora_fin_jornada?.getHours()!;

    if (startHour > endHour) {
      setAlert(
        true,
        "La hora de inicio debe ser menor a la hora de fin. Verifique las horas o el sistema horario (AM o PM).",
        AlertSeverityEnum.error,
      );
      return;
    }

    const hoursToWork = hoursBetweenRange(startHour, endHour);
    const daysToWork = form.getValues().workDays;
    let aux_dias_permitidos: any = null;
    if (hoursToWork && daysToWork) {
      aux_dias_permitidos = getDiasPermitidos(hoursToWork, daysToWork);
    }

    data.bodegas = dataBodegas.map((e) => e.codigo);
    data.ubicaciones = dataUbicacion.map((e) => e.codigo);
    data.bodegas_destino = dataBodegasDestino.map((e) => e.codigo);
    data.ubicaciones_destino = dataUbicacionDestino.map((e) => e.codigo);

    ///* upd
    if (systemUsuer?.id) {
      //console.log('update',data.is_active)
      updateUser.mutate({
        id: systemUsuer?.id,
        data: {
          ...systemUsuer,
          ...data,
          is_active: data.is_active!,
          grupos: data?.grupos || [],
          permisos: [],
          dias_permitidos: await aux_dias_permitidos,
        },
      });
      return;
    }

    // ///* create
    createUser.mutate({
      ...systemUsuer,
      ...data,
      grupos: data?.grupos || [],
      permisos: [],
      dias_permitidos: await aux_dias_permitidos,
    });
  };

  const handleConsultaIdentificacion = async (value: string) => {
    if (watchedTipoIdentificacion === TipoDocumentoNameEnum.CEDULA) {
      const res = await consultaIdentificacion.mutateAsync({
        identificacion: value,
      });
      const { data } = res;
      if (!data) return;

      form.setValue("razon_social", data?.razon_social);

      return;
    }

    if (watchedTipoIdentificacion === TipoDocumentoNameEnum.RUC) {
      const res = await consultaIdentificacion.mutateAsync({
        identificacion: value,
      });
      const data: IDataRuc = res?.data as unknown as IDataRuc;

      form.setValue("razon_social", data?.razonSocial);

      return;
    }
  };

  ///* effects ---------------------
  useEffect(() => {
    if (!systemUsuer) return;

    setCanWritePassword(false);

    //console.log(form.getValues());

    const {
      groups,
      profile,
      empleado,
      bodega_data,
      ubicacion_data,
      bodega_destino_data,
      ubicacion_destino_data,
      ...rest
    } = systemUsuer;

    //Auxiliares para ubicar horas basandose en el array de horas que trabaja
    const [horaInicio, horaFin] = getTimesForClockInWorkSchedules(
      profile?.dias_permitidos?.[0]?.horas!,
    );

    form.reset({
      ...rest,
      ...profile,
      dias_permitidos: profile?.dias_permitidos,
      grupos: groups?.map((item: any) => item.id),
      permisos: [],
      isEdit: true,

      // employee
      direccion: empleado?.direccion || "",
      telefono_1: empleado?.telefono_1 || "",
      telefono_2: empleado?.telefono_2 || "",
      telefono_3: empleado?.telefono_3 || "",
      pais: empleado?.pais || "",
      provincia: empleado?.provincia || "",
      ciudad: empleado?.ciudad || "",
      zona: empleado?.zona || "",
      sector: empleado?.sector || "",
      cargo: empleado?.cargo || "",
      tipo_empleado: empleado?.tipo_empleado || "",

      workDays: profile?.dias_permitidos?.map((item: any) => item.dia),
      hora_inicio_jornada: horaInicio!,
      hora_fin_jornada: horaFin!,
      cantidad_consultas: profile?.cantidad_consultas || 0,
    });

    const canSelectCanalVenta = AVAILABLE_ROLES_ACTIONS.includes(
      (profile?.rol as any) || "",
    );

    console.log("DEBUG", profile);

    setDataBodegas(bodega_data ?? []);
    setDataUbicacion(ubicacion_data ?? []);

    setDataBodegasDestino(bodega_destino_data ?? []);
    setDataUbicacionDestino(ubicacion_destino_data ?? []);

    setCanSelectCanalVenta(canSelectCanalVenta);
  }, [systemUsuer?.codigo]);

  // // alerts ----
  // area
  useEffect(() => {
    if (isLoadingAreas || isRefetchingAreas) return;

    if (watchedEmpresa && !areaPagingRes?.data?.data?.length)
      setAlert(
        true,
        "No se encontraron áreas asociadas a la empresa seleccionada.",
        AlertSeverityEnum.warning,
      );
  }, [isLoadingAreas, isRefetchingAreas, areaPagingRes, watchedEmpresa]);
  // departamentos
  useEffect(() => {
    if (isLoadingDepartamentos || isRefetchingDepartamentos) return;

    if (watchedArea && !departamentoPagingRes?.data?.data?.length)
      setAlert(
        true,
        "No se encontraron departamentos asociados al área seleccionada.",
        AlertSeverityEnum.warning,
      );
  }, [
    isLoadingDepartamentos,
    isRefetchingDepartamentos,
    departamentoPagingRes,
    watchedArea,
  ]);

  // cargos
  useEffect(() => {
    if (
      isLoadingCargos ||
      isRefetchingCargos ||
      !watchedEmpresa ||
      !watchedCreateEmployee
    )
      return;

    if (!cargosPagingRes?.data?.data?.length)
      setAlert(
        true,
        "No se encontraron cargos asociados a la empresa seleccionada.",
        AlertSeverityEnum.warning,
      );
  }, [
    isLoadingCargos,
    isRefetchingCargos,
    cargosPagingRes,
    watchedEmpresa,
    watchedCreateEmployee,
  ]);
  // province
  useEffect(() => {
    if (isLoadingProvinces || isRefetchingProvinces) return;

    if (watchedCountry && !provincesPaging?.data?.data?.length) {
      setAlert(
        true,
        "No se encontraron provincias disponibles",
        AlertSeverityEnum.warning,
      );
    }
  }, [
    watchedCountry,
    provincesPaging,
    isLoadingProvinces,
    isRefetchingProvinces,
  ]);
  // city
  useEffect(() => {
    if (isLoadingCities || isRefetchingCities) return;

    if (watchedProvince && !citiesPaging?.data?.data?.length) {
      setAlert(
        true,
        "No se encontraron ciudades disponibles",
        AlertSeverityEnum.warning,
      );
    }
  }, [watchedProvince, citiesPaging, isLoadingCities, isRefetchingCities]);
  // zone
  useEffect(() => {
    if (isLoadingZones || isRefetchingZones) return;

    if (watchedCity && !zonesPaging?.data?.data?.length) {
      setAlert(
        true,
        "No se encontraron zonas disponibles",
        AlertSeverityEnum.warning,
      );
    }
  }, [watchedCity, zonesPaging, isLoadingZones, isRefetchingZones]);
  // sectors
  useEffect(() => {
    if (isLoadingSectors || isRefetchingSectors) return;

    if (watchedZone && !sectorsPaging?.data?.data?.length) {
      setAlert(
        true,
        "No se encontraron sectores disponibles",
        AlertSeverityEnum.warning,
      );
    }
  }, [watchedZone, sectorsPaging, isLoadingSectors, isRefetchingSectors]);

  ///* handle

  const isLoadingData =
    isLoadingEmpresas ||
    isRefetchingEmpresas ||
    isLoadingAreas ||
    isRefetchingAreas ||
    isLoadingDepartamentos ||
    isRefetchingDepartamentos ||
    isLoadingGruposSistema ||
    isRefetchingGruposSistema ||
    isLoadingCanalesVenta ||
    isRefetchingCanalesVenta;

  const isLoadingLocation =
    isLoadingCountries ||
    isRefetchingCountries ||
    isLoadingProvinces ||
    isRefetchingProvinces ||
    isLoadingCities ||
    isRefetchingCities ||
    isLoadingZones ||
    isRefetchingZones ||
    isLoadingSectors ||
    isRefetchingSectors;

  useLoaders(isLoadingData || isLoadingLocation);

  if (
    systemUsuer &&
    (isLoadingEmpresas ||
      isRefetchingEmpresas ||
      isLoadingAreas ||
      isLoadingDepartamentos ||
      isLoadingGruposSistema)
  )
    return;

  // const resultado = DAYS_WEEK_COLLECTION?.data.filter((item: WorkDaysCollection) =>
  //   form.getValues('workDays')?.includes(item.dia!) || [])
  // const resultado = DAYS_WEEK_COLLECTION?.data.filter(item =>
  //   form.getValues('workDays')?.includes(item.dia)
  // );
  // console.log({resultado})

  // console.log({veamosjaja: DAYS_WEEK_COLLECTION?.data.filter((item: WorkDaysCollection) =>
  //   form.getValues('workDays')?.includes(item.dia!))})
  return (
    <TabsFormBoxScene
      titlePage={title}
      showCustomBtns={true}
      onCancel={() => navigate(returnUrlUsuariosSistemaPage)}
      onSave={form.handleSubmit(onSave, () => {
        setAlert(
          true,
          "Complete los campos requeridos",
          AlertSeverityEnum.error,
        );
      })}
      tabs={
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="DATOS USUARIO" value={1} {...a11yProps(1)} />

          {!!watchedCreateEmployee && (
            <Tab label="DATOS EMPLEADO" value={2} {...a11yProps(2)} />
          )}
          <Tab label="OTROS" value={3} {...a11yProps(3)} />
        </FormTabsOnly>
      }
      children={
        <>
          {/* ======================== User and Groups ======================== */}
          <CustomTabPanel index={1} value={valueTab}>
            <>
              <TabTextLabel text="Datos Personales" pb="33px" />
              <CustomAutocompleteArrString
                label="Tipo de identificación"
                name="tipo_identificacion"
                control={form.control}
                defaultValue={form.getValues("tipo_identificacion")}
                options={TIPO_IDENTIFICACIONES_CHOICE}
                isLoadingData={false}
                error={errors.tipo_identificacion}
                helperText={errors.tipo_identificacion?.message}
                size={gridSizeMdLg6}
                disableClearable
                onChangeValue={() => {
                  form.setValue("identificacion", "");
                  form.setValue("razon_social", "");
                }}
              />
              <Grid item xs={12} md={6} container spacing={1}>
                <Grid item xs={12} md={10}>
                  <IdentificacionTextField
                    control={form.control}
                    name="identificacion"
                    label="Identificación"
                    defaultValue={form.getValues().identificacion || ""}
                    error={errors.identificacion}
                    helperText={errors.identificacion?.message}
                    //
                    disabled={!watchedTipoIdentificacion}
                    selectedDocumentType={watchedTipoIdentificacion}
                    onFetchCedulaRucInfo={handleConsultaIdentificacion}
                    size={gridSize}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SingleIconButton
                    startIcon={<SearchIcon />}
                    label="Buscar"
                    color={"default" as any}
                    onClick={() => {
                      if (
                        !form.getValues().identificacion ||
                        !watchedTipoIdentificacion ||
                        (watchedTipoIdentificacion ===
                          TipoDocumentoNameEnum.CEDULA &&
                          form.getValues().identificacion.length !== 10) ||
                        (watchedTipoIdentificacion ===
                          TipoDocumentoNameEnum.RUC &&
                          form.getValues().identificacion.length !== 13)
                      )
                        return setAlert(
                          true,
                          "Ingrese una identificación válida",
                          AlertSeverityEnum.warning,
                        );

                      handleConsultaIdentificacion(
                        form.getValues().identificacion,
                      );
                    }}
                  />
                </Grid>
              </Grid>
              <CustomTextField
                label="Razon social"
                name="razon_social"
                control={form.control}
                defaultValue={form.getValues().razon_social}
                error={errors.razon_social}
                helperText={errors.razon_social?.message}
              />
              <CustomTextField
                label="Correo Electrónico"
                name="email"
                control={form.control}
                defaultValue={form.getValues().email}
                error={errors.email}
                helperText={errors.email?.message}
                type="email"
              />
              <CustomTextField
                label="Username"
                name="username"
                control={form.control}
                defaultValue={form.getValues().username}
                error={errors.username}
                helperText={errors.username?.message}
                size={gridSizeMdLg6}
                overrideAsPassword
              />
              <CustomTextField
                label="Cantidad de Consultas"
                name="cantidad_consultas"
                control={form.control}
                type="number"
                defaultValue={form.getValues().cantidad_consultas!}
                error={errors.cantidad_consultas}
                helperText={errors.cantidad_consultas?.message}
                size={gridSizeMdLg6}
              />

              <Grid item xs={12} md={6} container>
                <CustomPasswordTextField
                  label="Contraseña"
                  name="password"
                  form={form}
                  errors={errors}
                  size={!systemUsuer ? gridSize : gridSizeMdLg10}
                  disabled={!canWritePassword}
                />
                {systemUsuer && (
                  <Grid item xs={12} md={2}>
                    <SingleIconButton
                      label="Cambiar Contraseña"
                      startIcon={<EditIcon />}
                      color={"default" as any}
                      onClick={() => {
                        setCanWritePassword(true);
                      }}
                    />
                  </Grid>
                )}
              </Grid>

              {/* ====== fk ====== */}
              <CustomAutocomplete<Empresa>
                label="Empresa"
                name="empresa"
                // options
                options={empresaPagingRes?.data?.data || []}
                valueKey="razon_social"
                actualValueKey="codigo"
                defaultValue={form.getValues().empresa}
                isLoadingData={isLoadingEmpresas}
                // vaidation
                control={form.control}
                error={errors.empresa}
                helperText={errors.empresa?.message}
                size={gridSizeMdLg6}
              />
              <CustomAutocomplete<Area>
                label="Area"
                name="area"
                // options
                options={areaPagingRes?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={form.getValues().area}
                isLoadingData={isLoadingAreas}
                // vaidation
                control={form.control}
                error={errors.area}
                helperText={errors.area?.message}
                size={gridSizeMdLg6}
              />
              <CustomAutocomplete<Departamento>
                label="Departamento"
                name="departamento"
                // options
                options={departamentoPagingRes?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={form.getValues().departamento}
                isLoadingData={isLoadingDepartamentos}
                // vaidation
                control={form.control}
                error={errors.departamento}
                helperText={errors.departamento?.message}
                size={gridSizeMdLg6}
              />
              <CustomAutocompleteArrString
                label="ROL"
                name="rol"
                control={form.control}
                defaultValue={form.getValues("rol")}
                options={USER_ROLES_CHOICE}
                isLoadingData={false}
                error={errors.rol}
                helperText={errors.rol?.message}
                size={gridSizeMdLg6}
                disableClearable
                onChangeValue={(role) => {
                  const canSelectCanalVenta =
                    AVAILABLE_ROLES_ACTIONS.includes(role);
                  setCanSelectCanalVenta(canSelectCanalVenta);
                  form.setValue("canales_venta_adicionales", []);
                }}
              />

              {/* ----------- canal ventas ----------- */}
              <>
                {canSelectCanalVenta ? (
                  <>
                    <CustomAutocomplete<CanalVenta>
                      label="Canal de Venta"
                      name="canal_venta"
                      // options
                      options={canalesVentaPagingRes?.data?.data || []}
                      valueKey="nombre"
                      actualValueKey="codigo"
                      defaultValue={form.getValues().canal_venta}
                      isLoadingData={isLoadingCanalesVenta}
                      // vaidation
                      control={form.control}
                      error={errors.canal_venta}
                      helperText={errors.canal_venta?.message}
                      required={false}
                      size={gridSizeMdLg6}
                    />

                    <AcutocompletePromocion
                      label="Canal Venta Adicional"
                      name="canales_venta_adicionales"
                      textFieldKey="canales_venta_adicionales"
                      valueKey={"nombre"}
                      actualValueKey="codigo"
                      //option
                      options={canalesVentaPagingRes?.data.data || []}
                      defaultValue={
                        canalesVentaPagingRes?.data.data.filter(
                          (item: CanalVenta) =>
                            form
                              .getValues("canales_venta_adicionales")
                              ?.includes(item.codigo!),
                        ) || []
                      }
                      isLoadingData={isLoadingCanalesVenta}
                      error={!!errors.canal_venta}
                      control={form.control}
                      helperText={errors.canal_venta?.message}
                      size={gridSizeMdLg12}
                      onChangeRawValue={(e) => {
                        form.setValue(
                          "canales_venta_adicionales",
                          e?.map((item) => item?.codigo!),
                        );
                      }}
                    />
                  </>
                ) : null}
              </>
            </>

            {/*Bodegas*/}
            {/* <AcutocompletePromocion
              label="Bodegas"
              name="bodegas"
              textFieldKey="bodegas"
              valueKey={"nombre"}
              actualValueKey="codigo"
              //option
              options={bodegasPagingRes?.data.data || []}
              defaultValue={
                bodegasPagingRes?.data.data.filter(
                  (item: BODEGAS) =>
                    form
                      .getValues("bodegas")
                      ?.includes(item.codigo!)
                ) || []
              }
              isLoadingData={isLoadingBodegas}
              error={!!errors.bodegas}
              control={form.control}
              helperText={errors.bodegas?.message}
              size={gridSizeMdLg12}
              onChangeRawValue={(e) => {
                form.setValue(
                  "bodegas",
                  e?.map((item) => item?.codigo!)
                );
              }}
            /> */}

            {/*Ubicacion*/}

            {/* <AcutocompletePromocion
              //disabled={!watchedBodegas?.length}
              label="Ubicación"
              name="ubicaciones"
              textFieldKey="ubicaciones"
              valueKey={"nombre"}
              actualValueKey="codigo"
              //option
              options={ubicacionesPagingRes?.data.data || []}
              value={
                ubicacionesPagingRes?.data.data.filter(
                  (item: Ubicaciones) =>
                    form
                      .getValues("ubicaciones")
                      ?.includes(item.codigo!)
                ) || []
              }
              defaultValue={
                ubicacionesPagingRes?.data.data.filter(
                  (item: Ubicaciones) =>
                    form
                      .getValues("ubicaciones")
                      ?.includes(item.codigo!)
                ) || []
              }

              isLoadingData={isLoadingUbicaciones}
              error={!!errors.ubicaciones}
              control={form.control}
              helperText={errors.ubicaciones?.message}
              size={gridSizeMdLg12}
              onChangeRawValue={(e) => {
                console.log(e);

                form.reset({
                  ...form.getValues(),
                  ubicaciones:
                    e?.map((item) => item?.codigo!)
                }
                );
              }}
            /> */}

            {/* <CustomAutocompleteFetchMultipleForm<BODEGAS, any, string>

              required={false}
              control={form.control}
              size={gridSizeMdLg12}
              disabled={false}
              name="bodegas"
              label="Bodega"
              fetchData={fetchAutocompleteBodega}
              isAll={false}
              getOptionLabel={(o) => o.nombre ?? '—'}
              getOptionKey={(o) => o.codigo!}
              onChangeValue={(e) => {

              }}
            />

            <CustomAutocompleteFetchMultipleForm<Ubicaciones, any, string>

              required={false}
              control={form.control}
              size={gridSizeMdLg12}
              disabled={false}
              name="ubicaciones"
              label="Ubicación"
              fetchData={fetchAutocompleteUbicacion}
              isAll={false}
              getOptionLabel={(o) => o.nombre ?? '—'}
              getOptionKey={(o) => o.codigo!}
              onChangeValue={(e) => {

              }}
            /> */}

            <Grid item container {...gridSizeMdLg12}>
              <SampleCheckbox
                label="¿Crear Empleado?"
                name="create_employee"
                control={form.control}
                defaultValue={!!form.getValues().create_employee || false}
                size={gridSizeMdLg6}
                onChangeValue={(v) => {
                  !!v &&
                    setAlert(true, "Ingrese los datos del empleado", "info");
                }}
                disabled={!!systemUsuer && !!systemUsuer?.create_employee}
                onClickDisabled={() => {
                  setAlert(
                    true,
                    "Una vez asociado un empleado, este no podrá ser desvinculado",
                    AlertSeverityEnum.warning,
                  );
                }}
              />

              <SampleCheckbox
                label="Activo"
                name="is_active"
                isState
                control={form.control}
                defaultValue={!!form.getValues().is_active}
                size={gridSizeMdLg6}
              />
            </Grid>

            {/* ===== Permisos ===== */}
            <TabTextLabel text="Grupos (Opcional)" pt="39px" pb="3px" />
            <AcutocompletePromocion<GrupoSistema>
              size={gridSizeMdLg12}
              label="Grupos"
              name="grupos"
              textFieldKey="grupos"
              valueKey="name"
              actualValueKey="id"
              // options
              options={gruposSistemaPagingRes?.data?.data || []}
              defaultValue={
                // avoid error reference
                gruposSistemaPagingRes?.data?.data?.filter(
                  (item: GrupoSistema) =>
                    form.getValues("grupos")?.includes(item?.id!),
                ) || []
              }
              isLoadingData={isLoadingGruposSistema}
              // errors
              control={form.control}
              error={!!errors.grupos}
              helperText={errors.grupos?.message}
              onChangeRawValue={(v) => {
                form.setValue(
                  "grupos",
                  v?.map((item: GrupoSistema) => item?.id!),
                );
              }}
            />
          </CustomTabPanel>

          {/* ======================== Employee ======================== */}
          <CustomTabPanel index={2} value={valueTab}>
            <TabTextLabel text="Datos Contacto" pb="33px" />

            <>
              <CustomTextField
                label="Dirección"
                name="direccion"
                control={form.control}
                defaultValue={form.getValues().direccion}
                error={errors.direccion}
                helperText={errors.direccion?.message}
                size={gridSizeMdLg6}
              />
              <CustomCellphoneTextField
                label="Teléfono 1"
                name="telefono_1"
                control={form.control}
                defaultValue={form.getValues().telefono_1}
                error={errors.telefono_1}
                helperText={errors.telefono_1?.message}
                size={gridSizeMdLg6}
              />
              <CustomCellphoneTextField
                label="Teléfono 2"
                name="telefono_2"
                control={form.control}
                defaultValue={form.getValues().telefono_2}
                error={errors.telefono_2}
                helperText={errors.telefono_2?.message}
                size={gridSizeMdLg6}
              />
              <CustomCellphoneTextField
                label="Teléfono 3"
                name="telefono_3"
                control={form.control}
                defaultValue={form.getValues().telefono_3}
                error={errors.telefono_3}
                helperText={errors.telefono_3?.message}
                size={gridSizeMdLg6}
              />

              {/* -------- Cargo -------- */}
              <TabTextLabel text="Cargo" pt="39px" pb="3px" />
              <CustomAutocomplete<Cargos>
                label="Cargo"
                name="cargo"
                // options
                options={cargosPagingRes?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={form.getValues().cargo}
                isLoadingData={isLoadingEmpresas}
                // vaidation
                control={form.control}
                error={errors.cargo}
                helperText={errors.cargo?.message}
                size={gridSizeMdLg6}
              />
              <CustomAutocompleteArrString
                label="Tipo Empleado"
                name="tipo_empleado"
                control={form.control}
                defaultValue={form.getValues("tipo_empleado")}
                options={TIPO_EMPLEADO_CHOICE}
                isLoadingData={false}
                error={errors.tipo_empleado}
                helperText={errors.tipo_empleado?.message}
                size={gridSizeMdLg6}
                disableClearable
              />
              {/* ---------- Horarios --------- */}
              <TabTextLabel text="Horario de Empleado" pt="39px" pb="3px" />

              <AcutocompletePromocion<WorkDaysCollection>
                label="Días laborales"
                name="workDays"
                textFieldKey="workDays"
                valueKey="nombreDia"
                actualValueKey="dia"
                // options
                options={DAYS_WEEK_COLLECTION?.data || []}
                defaultValue={// avoid error reference
                DAYS_WEEK_COLLECTION?.data.filter((item: WorkDaysCollection) =>
                  form.getValues()?.workDays?.includes(item.dia!),
                )}
                isLoadingData={false}
                // errors
                control={form.control}
                error={!!errors.workDays}
                helperText={errors.workDays?.message}
                onChangeRawValue={(v) => {
                  form.setValue(
                    "workDays",
                    v?.map((item: WorkDaysCollection) => item?.dia!),
                  );
                }}
              />
              <TimeClockComponente
                size={gridSizeMdLg6}
                control={form.control}
                error={errors.hora_inicio_jornada}
                // helperText={""}//errors.hora_inicio?.message}
                label="Hora de inicio jornada"
                name="hora_inicio_jornada"
                enableDateTypeResult={true}
              />
              <TimeClockComponente
                size={gridSizeMdLg6}
                control={form.control}
                error={errors.hora_fin_jornada}
                // helperText={""}//errors.hora_inicio?.message}
                label="Hora de fin jornada"
                name="hora_fin_jornada"
                enableDateTypeResult={true}
              />

              {/* -------- Ubicacion -------- */}
              <TabTextLabel text="Ubicación" pt="39px" pb="3px" />
              {!isLoadingLocation ? (
                <>
                  <CustomAutocomplete<Country>
                    label="País"
                    name="pais"
                    // options
                    options={countriesPaging?.data?.data || []}
                    valueKey="nombre"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().pais || ""}
                    optionLabelForEdit={form.getValues().pais || ""}
                    isLoadingData={isLoadingCountries}
                    // validation
                    control={form.control}
                    error={errors.pais}
                    helperText={errors.pais?.message}
                    size={gridSizeMdLg6}
                    onChangeValue={() => {
                      form.setValue("provincia", "");
                      form.setValue("ciudad", "");
                      form.setValue("zona", "");
                      form.setValue("sector", "");
                    }}
                  />
                  <CustomAutocomplete<Province>
                    label="Provincia"
                    name="provincia"
                    // options
                    options={provincesPaging?.data?.data || []}
                    valueKey="nombre"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().provincia || ""}
                    optionLabelForEdit={form.getValues().provincia || ""}
                    isLoadingData={isLoadingProvinces}
                    // validation
                    control={form.control}
                    error={errors.provincia}
                    helperText={errors.provincia?.message}
                    size={gridSizeMdLg6}
                    onChangeValue={() => {
                      form.setValue("ciudad", "");
                      form.setValue("zona", "");
                      form.setValue("sector", "");
                    }}
                  />
                  <CustomAutocomplete<City>
                    label="Ciudad"
                    name="ciudad"
                    // options
                    options={citiesPaging?.data?.data || []}
                    valueKey="nombre"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().ciudad || ""}
                    optionLabelForEdit={form.getValues().ciudad}
                    isLoadingData={isLoadingCities}
                    // validation
                    control={form.control}
                    error={errors.ciudad}
                    helperText={errors.ciudad?.message}
                    size={gridSizeMdLg6}
                    onChangeValue={() => {
                      form.setValue("zona", "");
                      form.setValue("sector", "");
                    }}
                  />
                  <CustomAutocomplete<Zone>
                    label="Zona"
                    name="zona"
                    // options
                    options={zonesPaging?.data?.data || []}
                    valueKey="nombre"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().zona || ""}
                    optionLabelForEdit={form.getValues().zona}
                    isLoadingData={isLoadingZones}
                    // validation
                    control={form.control}
                    error={errors.zona}
                    helperText={errors.zona?.message}
                    size={gridSizeMdLg6}
                    onChangeValue={() => {
                      form.setValue("sector", "");
                    }}
                  />
                  <CustomAutocomplete<Sector>
                    label="Sector"
                    name="sector"
                    // options
                    options={sectorsPaging?.data?.data || []}
                    valueKey="nombre"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().sector || ""}
                    optionLabelForEdit={form.getValues().sector}
                    isLoadingData={isLoadingSectors}
                    // validation
                    control={form.control}
                    error={errors.sector}
                    helperText={errors.sector?.message}
                    // size={gridSizeMdLg6}
                  />
                </>
              ) : (
                <CustomCircularPorgress />
              )}
            </>
          </CustomTabPanel>

          {/* ======================== OTROS ======================== */}
          <CustomTabPanel index={3} value={valueTab}>
            <TabTextLabel
              text="Bodega y ubicación Origen"
              pb={3}
              pl={0}
              pt={3}
              mt={0}
            />

            <Grid container spacing={3}>
              <AgregarBodegaUsuario
                dataBodegas={dataBodegas}
                setDataBodegas={setDataBodegas}
              />
              <AgregarUbicacionUsuario
                dataUbicacion={dataUbicacion}
                setDataUbicacion={setDataUbicacion}
              />
            </Grid>

            <TabTextLabel
              text="Bodega y ubicación Destino"
              pb={3}
              pl={0}
              pt={3}
              mt={0}
            />

            <Grid container spacing={3}>
              <AgregarBodegaUsuario
                dataBodegas={dataBodegasDestino}
                setDataBodegas={setDataBodegasDestino}
              />
              <AgregarUbicacionUsuario
                dataUbicacion={dataUbicacionDestino}
                setDataUbicacion={setDataUbicacionDestino}
              />
            </Grid>
          </CustomTabPanel>
        </>
      }
    ></TabsFormBoxScene>
  );
};

export default SaveUsuarioSistema;
